import { render, staticRenderFns } from "./ActiveClaims.vue?vue&type=template&id=4f2546e9&scoped=true"
import script from "./ActiveClaims.vue?vue&type=script&lang=js"
export * from "./ActiveClaims.vue?vue&type=script&lang=js"
import style0 from "./ActiveClaims.vue?vue&type=style&index=0&id=4f2546e9&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2546e9",
  null
  
)

export default component.exports